import React from 'react';
import { Pill } from '@/components/ui/Pill';
import { LazySection } from '@/components/ui/LazySection';

interface FilterOption {
  key: string;
  label: string;
  options: string[];
  selected: string[];
  setSelected: (v: string[]) => void;
  loading?: boolean;
}

interface ProductActiveFiltersProps {
  filters: FilterOption[];
  onClearFilters: () => void;
  viewMode: 'card' | 'list';
  setViewMode: (v: 'card' | 'list') => void;
}

export default function ProductActiveFilters(props: ProductActiveFiltersProps) {
  const anyActive = props.filters.some(filter => filter.selected.length > 0);
  
  return (
    <LazySection minHeight={40}>
      {/* Filter Pills */}
      <div className="flex flex-wrap items-center gap-2 mb-4">
        {props.filters.map((filter) =>
          filter.selected.map((value) => (
            <Pill key={`${filter.key}-${value}`} type="selectedFilterCategory">
              {filter.label}: {value}
              <button 
                type="button" 
                className="ml-2 text-neutral-700 hover:text-neutral-900 font-bold focus:outline-none" 
                aria-label={`Remove ${filter.label} filter`} 
                onClick={() => filter.setSelected(filter.selected.filter((v) => v !== value))}
              >
                ×
              </button>
            </Pill>
          ))
        )}
      </div>

             {/* View Controls */}
       <div className="flex items-center justify-end w-full mb-3">
         {/* Clear Filters and View Toggles */}
         <div className="flex items-center gap-2">
           {anyActive && (
             <button type="button" className="bg-neutral-200 text-neutral-800 rounded-md px-4 py-2 text-sm font-sans font-medium hover:bg-neutral-300 transition-colors whitespace-nowrap" onClick={props.onClearFilters}>Clear Filters</button>
           )}
           <button type="button" aria-label="List View" aria-pressed={props.viewMode === 'list'} onClick={() => props.setViewMode('list')} className={`w-10 h-10 flex items-center justify-center rounded-lg transition-colors border-none focus:outline-none ${props.viewMode === 'list' ? 'bg-primary-100 text-primary-600' : 'bg-neutral-100 text-neutral-500'}`}>
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="6" width="24" height="2" rx="1" fill="currentColor" /><rect y="11" width="24" height="2" rx="1" fill="currentColor" /><rect y="16" width="24" height="2" rx="1" fill="currentColor" /></svg>
           </button>
           <button type="button" aria-label="Card/Grid View" aria-pressed={props.viewMode === 'card'} onClick={() => props.setViewMode('card')} className={`w-10 h-10 flex items-center justify-center rounded-lg transition-colors border-none focus:outline-none ${props.viewMode === 'card' ? 'bg-primary-100 text-primary-600' : 'bg-neutral-100 text-neutral-500'}`}>
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="7" height="7" rx="2" fill="currentColor" /><rect x="14" y="3" width="7" height="7" rx="2" fill="currentColor" /><rect x="3" y="14" width="7" height="7" rx="2" fill="currentColor" /><rect x="14" y="14" width="7" height="7" rx="2" fill="currentColor" /></svg>
           </button>
         </div>
       </div>
    </LazySection>
  );
}
